import { sortItems } from '@griply/utils';
import { useCallback, useMemo } from 'react';
import { useUpcomingCalendarViewOptions } from 'shared/contexts/upcoming-calendar-view-options';
import { ID } from 'shared/types/id';
import { ViewOptionsSectionEntry } from 'shared/types/view-options-section';

export type UseViewOptionsSectionOrderResult = {
  sections: ViewOptionsSectionEntry[];
  onReorder: (sectionIds: ID[]) => void;
};

export const useViewOptionsSectionOrder = (
  sections: ViewOptionsSectionEntry[],
): UseViewOptionsSectionOrderResult => {
  const { viewOptions, updateViewOptions } = useUpcomingCalendarViewOptions();
  const { sectionOrder } = viewOptions;

  const orderedSections = useMemo(
    () => sortItems(sections, sectionOrder, 'id'),
    [sections, sectionOrder],
  );

  const onReorder = useCallback(
    (sectionIds: ID[]) => updateViewOptions({ sectionOrder: sectionIds }),
    [updateViewOptions],
  );

  return { sections: orderedSections, onReorder };
};
